import React, { FC, ReactNode, useEffect, useState } from 'react';
import Header from '../header';
import Footer from '../footer';
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import { HEADER_DESKTOP_PX, HEADER_MOBILE_PX, DRAWER_WIDTH } from '../header/constants';
import { SidebarItemProps } from '../../components/sidebar/sidebar-item';

export interface DashboardLayoutProps {
    children?: ReactNode;
    navPages: SidebarItemProps[];
    includeLogo?: boolean;
}

const DashboardLayout: FC<DashboardLayoutProps> = ({ children, navPages, includeLogo = false }) => {
    const theme = useTheme();
    const mediaDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const [drawerOpen, setDrawerState] = useState<boolean>(mediaDesktop);

    const toggleDrawer = () => {
        if (mediaDesktop) return;
        setDrawerState((prevState) => !prevState);
    };

    useEffect(() => {
        setDrawerState(mediaDesktop);
    }, [mediaDesktop]);

    const headerSize = mediaDesktop ? HEADER_DESKTOP_PX : HEADER_MOBILE_PX;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
            }}
        >
            <Header drawerOpen={drawerOpen} toggleDrawer={toggleDrawer} navPages={navPages} headerSize={headerSize} />
            
            <Container
                maxWidth={false}
                component='main'
                sx={{
                    width: mediaDesktop ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%',
                    margin: `${headerSize} auto 0 ${mediaDesktop ? DRAWER_WIDTH + 'px' : 'auto'}`,
                    padding: '28px 24px 14px',
                }}
            >
                {children}
            </Container>

            <Footer includeLogo={includeLogo} />
        </Box>
    );
};

export default DashboardLayout;
